import axios from 'axios';
import { handleRequest, makeFailure, makeSuccess } from "../infra/utils";

function getChannelFromWindow(key) {
  const channel = window[key];
  return typeof channel === 'string' ? channel : '';
}

async function sendSlackMessage(url, text) {
  if (url) {
    return handleRequest(axios.post(url, JSON.stringify({
      text
    })));
  }

  return makeFailure('No URL');
}

export let SlackUserGroups;

(function (SlackUserGroups) {
  SlackUserGroups["ProductTeam"] = "<!subteam^S04FHKU667K|product-team>";
})(SlackUserGroups || (SlackUserGroups = {}));

const mockSendSlackMessage = async () => makeSuccess({
  data: {}
});

export const mockSlackClient = {
  sendCsNotificationsMessage: mockSendSlackMessage,
  sendRoleIntentLoggerMessage: mockSendSlackMessage
};
export const slackClient = {
  sendCsNotificationsMessage,
  sendRoleIntentLoggerMessage
};

function sendCsNotificationsMessage(text) {
  const csNotificationsChannel = getChannelFromWindow('slackCsChannelUrl');
  return sendSlackMessage(csNotificationsChannel, text);
}

function sendRoleIntentLoggerMessage(text) {
  const roleIntentLoggerChannel = getChannelFromWindow('slackRoleIntentLoggerChannelUrl');
  return sendSlackMessage(roleIntentLoggerChannel, text);
}